import type { OrderGroupId } from "@@/shared/order-groups/order-group-id";
import type { UserId} from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import type { UUID } from "@@/shared/uuid";
import { z } from "zod";
import type { OrderId } from "../order-id";
import {
    _orderStatusBaseFactory,
    _orderStatusBaseZodSchema,
} from "./_order-status-base";

const orderStatusPaymentFailedZodSchema = _orderStatusBaseZodSchema.merge(
    z.object({
        type: z.literal("PAYMENT_FAILED"),
        createdBy: userIdZodSchema.or(z.string()),
        paymentUUID: z.string() as unknown as z.ZodType<UUID>,
        reason: z.string(),
        reasonCode: z.string(),
    }),
);
type OrderPaymentFailed = z.infer<typeof orderStatusPaymentFailedZodSchema>;

const orderStatusPaymentFailedFactory = (params: {
    readonly orderId: OrderId;
    readonly orderGroupId: OrderGroupId;
    readonly createdBy: UserId | string;
    readonly paymentUUID: UUID;
    readonly reason: string;
    readonly reasonCode: string;
}): OrderPaymentFailed => ({
    ..._orderStatusBaseFactory(params.orderId, params.orderGroupId),
    type: "PAYMENT_FAILED",
    createdBy: params.createdBy,
    paymentUUID: params.paymentUUID,
    reason: params.reason,
    reasonCode: params.reasonCode,
});

export { orderStatusPaymentFailedFactory, orderStatusPaymentFailedZodSchema };
export type { OrderPaymentFailed };
